module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\nin vec2 fs_UV;\n\nuniform sampler2D u_Sampler;\n\nout vec4 out_Col;\n\nvoid main()\n{\n    // float dist = 1.0 - (length(fs_Pos.xyz) * 2.0);\n    // out_Col = vec4(dist) * fs_Col;\n    // out_Col = texture2D(u_Sampler, fs_UV);\n    out_Col = texture(u_Sampler, fs_UV);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/instanced-frag.glsl
// module id = 71
// module chunks = 0